"use strict";

var _regeneratorRuntime = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/Volumes/Github-Projects/book-package-viewer-poc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var cov_29ha52brg = function () {
  var path = "/Volumes/Github-Projects/gitea-react-toolkit/src/components/core/Core.js";
  var hash = "52b4bbdbaf657cd1aa9ee66167800e3c551b4d2f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/Volumes/Github-Projects/gitea-react-toolkit/src/components/core/Core.js",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 46
        },
        end: {
          line: 13,
          column: 60
        }
      },
      "1": {
        start: {
          line: 14,
          column: 34
        },
        end: {
          line: 14,
          column: 44
        }
      },
      "2": {
        start: {
          line: 15,
          column: 32
        },
        end: {
          line: 15,
          column: 47
        }
      },
      "3": {
        start: {
          line: 16,
          column: 49
        },
        end: {
          line: 16,
          column: 129
        }
      },
      "4": {
        start: {
          line: 17,
          column: 31
        },
        end: {
          line: 17,
          column: 89
        }
      },
      "5": {
        start: {
          line: 18,
          column: 19
        },
        end: {
          line: 31,
          column: 38
        }
      },
      "6": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "7": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 23
        }
      },
      "8": {
        start: {
          line: 21,
          column: 24
        },
        end: {
          line: 24,
          column: 8
        }
      },
      "9": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 29
        }
      },
      "10": {
        start: {
          line: 27,
          column: 21
        },
        end: {
          line: 27,
          column: 45
        }
      },
      "11": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 26
        }
      },
      "12": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 22
        }
      },
      "13": {
        start: {
          line: 33,
          column: 26
        },
        end: {
          line: 33,
          column: 33
        }
      },
      "14": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 37,
          column: 3
        }
      },
      "15": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 35
        }
      },
      "16": {
        start: {
          line: 39,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "17": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 53
        }
      },
      "18": {
        start: {
          line: 41,
          column: 9
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "19": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 62
        }
      },
      "20": {
        start: {
          line: 43,
          column: 9
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "21": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 38
        }
      },
      "22": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 60,
          column: 4
        }
      },
      "23": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 67,
          column: 2
        }
      },
      "24": {
        start: {
          line: 69,
          column: 0
        },
        end: {
          line: 72,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "Core",
        decl: {
          start: {
            line: 8,
            column: 9
          },
          end: {
            line: 8,
            column: 13
          }
        },
        loc: {
          start: {
            line: 12,
            column: 3
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 31
          },
          end: {
            line: 18,
            column: 32
          }
        },
        loc: {
          start: {
            line: 18,
            column: 43
          },
          end: {
            line: 31,
            column: 3
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 31
          },
          end: {
            line: 17,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 31
          },
          end: {
            line: 17,
            column: 43
          }
        }, {
          start: {
            line: 17,
            column: 47
          },
          end: {
            line: 17,
            column: 62
          }
        }, {
          start: {
            line: 17,
            column: 66
          },
          end: {
            line: 17,
            column: 89
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        }],
        line: 35
      },
      "2": {
        loc: {
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 35,
            column: 6
          },
          end: {
            line: 35,
            column: 25
          }
        }, {
          start: {
            line: 35,
            column: 29
          },
          end: {
            line: 35,
            column: 52
          }
        }],
        line: 35
      },
      "3": {
        loc: {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 39,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 39
      },
      "4": {
        loc: {
          start: {
            line: 41,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 41,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 41
      },
      "5": {
        loc: {
          start: {
            line: 43,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 43,
            column: 9
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 43
      },
      "6": {
        loc: {
          start: {
            line: 43,
            column: 13
          },
          end: {
            line: 43,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 13
          },
          end: {
            line: 43,
            column: 22
          }
        }, {
          start: {
            line: 43,
            column: 26
          },
          end: {
            line: 43,
            column: 59
          }
        }, {
          start: {
            line: 43,
            column: 63
          },
          end: {
            line: 43,
            column: 71
          }
        }],
        line: 43
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "52b4bbdbaf657cd1aa9ee66167800e3c551b4d2f"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJsonView = _interopRequireDefault(require("react-json-view"));

var _core = require("@material-ui/core");

var _ = require("..");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Core(_ref) {
  var promise = _ref.promise,
      props = _ref.props,
      authenticate = _ref.authenticate;
  cov_29ha52brg.f[0]++;

  var _ref2 = (cov_29ha52brg.s[0]++, (0, _react.useState)(null)),
      _ref3 = _slicedToArray(_ref2, 2),
      authentication = _ref3[0],
      setAuthentication = _ref3[1];

  var _ref4 = (cov_29ha52brg.s[1]++, (0, _react.useState)()),
      _ref5 = _slicedToArray(_ref4, 2),
      response = _ref5[0],
      setResponse = _ref5[1];

  var _ref6 = (cov_29ha52brg.s[2]++, (0, _react.useState)(false)),
      _ref7 = _slicedToArray(_ref6, 2),
      loading = _ref7[0],
      setLoading = _ref7[1];

  var _ref8 = (cov_29ha52brg.s[3]++, (0, _.useAuthentication)({
    config: props.config,
    onAuthentication: setAuthentication
  })),
      authenticationComponent = _ref8.component;

  var needsAuthentication = (cov_29ha52brg.s[4]++, (cov_29ha52brg.b[0][0]++, authenticate) && (cov_29ha52brg.b[0][1]++, !authentication) && (cov_29ha52brg.b[0][2]++, authenticationComponent));

  var _promise = (cov_29ha52brg.s[5]++, (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _response, _error;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cov_29ha52brg.f[1]++;
            cov_29ha52brg.s[6]++;
            _context.prev = 2;
            cov_29ha52brg.s[7]++;
            setLoading(true);
            cov_29ha52brg.s[8]++;
            _context.next = 8;
            return promise(_objectSpread({}, props, {}, authentication));

          case 8:
            _response = _context.sent;
            cov_29ha52brg.s[9]++;
            setResponse(_response);
            _context.next = 18;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            _error = (cov_29ha52brg.s[10]++, {
              error: _context.t0.message
            });
            cov_29ha52brg.s[11]++;
            setResponse(_error);

          case 18:
            cov_29ha52brg.s[12]++;
            setLoading(false);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13]]);
  })), [authentication, promise, props]));

  var responseComponent = (cov_29ha52brg.s[13]++, /*#__PURE__*/_react.default.createElement("div", null));
  cov_29ha52brg.s[14]++;

  if ((cov_29ha52brg.b[2][0]++, needsAuthentication) && (cov_29ha52brg.b[2][1]++, authenticationComponent)) {
    cov_29ha52brg.b[1][0]++;
    cov_29ha52brg.s[15]++;
    return authenticationComponent;
  } else {
    cov_29ha52brg.b[1][1]++;
  }

  cov_29ha52brg.s[16]++;

  if (response) {
    cov_29ha52brg.b[3][0]++;
    cov_29ha52brg.s[17]++;
    responseComponent = /*#__PURE__*/_react.default.createElement(_reactJsonView.default, {
      src: response
    });
  } else {
    cov_29ha52brg.b[3][1]++;
    cov_29ha52brg.s[18]++;

    if (loading) {
      cov_29ha52brg.b[4][0]++;
      cov_29ha52brg.s[19]++;
      responseComponent = /*#__PURE__*/_react.default.createElement(_reactJsonView.default, {
        src: {
          pending: true
        }
      });
    } else {
      cov_29ha52brg.b[4][1]++;
      cov_29ha52brg.s[20]++;

      if ((cov_29ha52brg.b[6][0]++, !response) && (cov_29ha52brg.b[6][1]++, typeof response !== 'undefined') && (cov_29ha52brg.b[6][2]++, !loading)) {
        cov_29ha52brg.b[5][0]++;
        cov_29ha52brg.s[21]++;
        responseComponent = 'No response';
      } else {
        cov_29ha52brg.b[5][1]++;
      }
    }
  }

  cov_29ha52brg.s[22]++;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, "Props"), /*#__PURE__*/_react.default.createElement(_core.Paper, null, /*#__PURE__*/_react.default.createElement(_reactJsonView.default, {
    src: props
  })), /*#__PURE__*/_react.default.createElement("h3", null, "Response"), /*#__PURE__*/_react.default.createElement(_core.Paper, null, responseComponent), /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    onClick: _promise
  }, "Run"));
}

;
cov_29ha52brg.s[23]++;
Core.propTypes = {
  props: _propTypes.default.object.isRequired,
  promise: _propTypes.default.func.isRequired,
  authenticate: _propTypes.default.bool
};
cov_29ha52brg.s[24]++;
Core.defaultProps = {
  authenticate: false,
  confirm: false
};
var _default = Core;
exports.default = _default;